import type { LetterPageByCityQuery } from './graphql/letter-page-by-city.query.gql-types';
import { PageNamesTypes } from './types';
import type { PopularNames, PageName } from './types';

export const sanitizePopularNames = (
  popularNames: NonNullable<
    NonNullable<
      LetterPageByCityQuery['peopleByCityTopLevelPage']
    >['popularNames']
  >
): PopularNames => {
  return (
    popularNames?.map((popularName) => ({
      name: popularName?.name || '',
      url: `${popularName?.url}` || '',
      count: popularName?.count || 0,
    })) || []
  );
};

export const sanitizeNames = (
  names: NonNullable<
    NonNullable<LetterPageByCityQuery['peopleByCityTopLevelPage']>['names']
  >
): Array<PageName> => {
  return (
    names
      ?.map((name): PageName | null => {
        const nameUrl = name?.url ? `https://www.xing.com${name.url}` : '';

        switch (name?.__typename) {
          case 'PeopleChildItem': {
            return {
              __typename: PageNamesTypes.child,
              name: name?.name || '',
              toName: name?.toName || '',
              url: nameUrl,
            };
          }
          case 'PeopleUserBagItem': {
            return {
              __typename: PageNamesTypes.userBag,
              name: name?.name || '',
              count: name?.count || 0,
              url: nameUrl,
            };
          }
          case 'PeopleProfileItem': {
            return {
              __typename: PageNamesTypes.profile,
              name: name?.name || '',
              photoUrl: name?.photoUrl || '',
              coach: name?.coach || false,
              url: nameUrl,
              occupationTitle: name?.occupationTitle || '',
              city: name?.city || '',
            };
          }
          default: {
            return null;
          }
        }
      })
      .reduce<Array<PageName>>((result, name: PageName | null) => {
        if (name) {
          return [...result, name];
        } else {
          return result;
        }
      }, []) || []
  );
};
